import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { STOCK_TERMS_HINT } from '../utils/stockConfirmation'

export const StockTermsHint: React.FC = () => (
  <Tooltip title={STOCK_TERMS_HINT}>
    <QuestionCircleOutlined
      style={{
        marginLeft: 6,
        fontSize: 13,
        color: 'rgba(0, 0, 0, 0.45)',
        cursor: 'help'
      }}
    />
  </Tooltip>
)
